window.bannerProjectSliderHandler = () => {
  document.addEventListener('DOMContentLoaded', () => {
    bannerProjectSliderEvents();
  });

  const bannerProjectSliderEvents = () => {
    const projectSliderContainers = document.querySelectorAll('.jsBannerProjectSliderContainer');

    projectSliderContainers.forEach(projectSlider => {
      const backgroundSlider = projectSlider.querySelector('.jsBannerProjectSliderBackground');
      const boxSlider = projectSlider.querySelector('.jsBannerProjectSliderBox');
      const prevButton = projectSlider.querySelector('.jsBannerProjectSliderPrev');
      const nextButton = projectSlider.querySelector('.jsBannerProjectSliderNext');

      // Background slider
      backgroundSlider && $(backgroundSlider).slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 800,
        asNavFor: '.jsBannerProjectSliderBox',
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 3000,
      });

      // Box slider
      boxSlider && $(boxSlider).slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 800,
        fade: true,
        asNavFor: '.jsBannerProjectSliderBackground',
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 3000,
      });

      prevButton && prevButton.addEventListener('click', (e) => {
        e.stopPropagation();
        $(boxSlider).slick('slickPrev');
      });

      nextButton && nextButton.addEventListener('click', (e) => {
        e.stopPropagation();
        $(boxSlider).slick('slickNext');
      });
    });
  }
};
